import React from 'react';
import clsx from 'clsx';
import { FieldShell } from 'components/ui/FieldShell';
import { useFormLocked } from 'components/ui/FormLock';
import controlStyles from 'components/ui/FieldShell/fieldControl.module.scss';

export interface ITextFieldProps {
  label: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  autoComplete?: string;
  className?: string;
}

export default function TextField({
  label,
  id,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  placeholder,
  type = 'text',
  onBlur,
  name,
  autoComplete,
  className,
}: ITextFieldProps) {
  const locked = useFormLocked();
  const isDisabled = disabled || locked;
  const errorId = error ? `${id}-error` : undefined;

  return (
    <FieldShell
      label={label}
      id={id}
      error={error}
      disabled={isDisabled}
      required={required}
      className={className}
    >
      <input
        id={id}
        name={name}
        type={type}
        className={clsx(
          controlStyles.control,
          error && controlStyles.controlError,
        )}
        value={value}
        onChange={event => {
          if (isDisabled) return;
          onChange(event.target.value);
        }}
        onBlur={onBlur}
        disabled={isDisabled}
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
      />
    </FieldShell>
  );
}
